export const buildTitle = (
  partnerName: string | null,
  storeName: string | null,
  productName: string | undefined,
  tagline: string | null
) => {
  const updatedTagline = tagline ? `| ${tagline}` : ''

  if (partnerName && storeName && productName) {
    return [
      partnerName,
      '|',
      productName,
      '- Order Online',
      '|',
      storeName
    ].join(' ')
  }

  if (partnerName && storeName) {
    return [partnerName, storeName, updatedTagline, '- Order Online'].join(' ')
  }

  if (partnerName) {
    return [partnerName, updatedTagline, '- Order Online'].join(' ')
  }

  return ''
}
